/**
 * Зависимые умолчания реестра (`defaultWhen`, auto-ads решение 172). Пример:
 * оптимизация «Ценность (pLTV)» → окно атрибуции «Клик 7 дн.».
 *
 * Два случая и только они:
 * - загрузка (`withDependentDefaults`): поле, которого НЕТ в сохранённом
 *   шаблоне / черновике, получает зависимое умолчание — как его считает
 *   сервер. Сохранённые значения не меняются никогда;
 * - смена зависимости человеком (`dependencyChange`): если человек в этой
 *   сессии не трогал поле, оно переключается на значение `defaultWhen`
 *   с заметной подсказкой; ушли с варианта — возвращается то, что было до
 *   автопереключения.
 */
const matchOf = (d, vals) => (d.defaultWhen ?? []).find((w) => w.in.some((v) => String(v) === String(vals[w.key])));
export function withDependentDefaults(descs, values, saved) {
    const out = { ...values };
    for (const d of descs) {
        if (!d.defaultWhen || Object.hasOwn(saved, d.key))
            continue;
        const hit = matchOf(d, out);
        if (hit)
            out[d.key] = hit.value;
    }
    return out;
}
/**
 * Человек поменял поле `changedKey` (событие изменения, не загрузка). `live` —
 * значения ПОСЛЕ изменения; `touched` — поля, которые человек трогал в этой
 * сессии; `before` — значения до автопереключения (ключ — поле).
 */
export function dependencyChange(descs, changedKey, live, touched, before) {
    const out = [];
    for (const d of descs) {
        if (!d.defaultWhen?.some((w) => w.key === changedKey))
            continue;
        if (touched.has(d.key))
            continue;
        const hit = matchOf(d, live);
        if (hit) {
            if (String(live[d.key]) === String(hit.value))
                continue;
            const option = d.options?.find((o) => String(o.value) === String(hit.value));
            out.push({
                key: d.key,
                value: hit.value,
                note: hit.note ??
                    `«${d.label}» переключено на «${option?.label ?? String(hit.value)}» — можно выбрать другое`,
                kind: 'switched',
            });
        }
        else if (before.has(d.key)) {
            out.push({ key: d.key, value: before.get(d.key), note: null, kind: 'restored' });
        }
    }
    return out;
}
//# sourceMappingURL=dependent-defaults.js.map